import { render } from "./PortfolioItem.vue?vue&type=template&id=21bd6600"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"

import "./PortfolioItem.vue?vue&type=style&index=0&id=21bd6600&lang=css"
script.render = render

export default script